import { Dialog, Stack } from '@mui/material';

import { Header } from '@app/sections/header';

interface CommonDialogProps {
  open: boolean;
  onClose: () => void;
  height?: any;
  sx?: object;
}

const CommingSoonDialog = ({ open, onClose, height = 400, sx = {} }: CommonDialogProps) => {
  return (
    <Dialog open={open} onClose={onClose} sx={sx}>
      <Header onClose={onClose} />
      <Stack>
        <img
          src={'/assets/images/comming-soon.png'}
          style={{
            objectFit: 'contain',
            height,
            width: '100%',
          }}
        />
      </Stack>
    </Dialog>
  );
};

export default CommingSoonDialog;
